import Mutation from './mutationTypes';

export default {
    [Mutation.SET_ACCORDION_OPTIONS]: (state, {payload}) => {
        state = Object.assign(state, payload);
        Object.assign(state.homeAccordions, state);
    },
    [Mutation.SET_HOME_ACCORDIONS]: (state, accordions) => {
        state.homeAccordions = accordions
    },
    [Mutation.SET_ACCORDION_CONTENT]: (state, {accordionName, accordionContent}) => {
        state[accordionName]["content"] = accordionContent;
    },
    [Mutation.SET_ACCORDION_FOOTER]: (state, {accordionName, accordionFooter}) => {
        state[accordionName]["footer"] = accordionFooter;
    },
    [Mutation.SET_LOADING_STATUS]: (state, status) => {
        state.loading = status
    },
    [Mutation.SET_LAWLEX_RECENT_SEARCHES](state, payload) {
        state.lawlexRecentSearches = payload;
    },
    [Mutation.SET_LAWLEX_US_SAVED_SEARCH](state, payload) {
        state.lawlexUsSavedSearches = payload;
    },
    [Mutation.SET_EURLEX_SAVED_SEARCH](state, payload) {
        state.eurlexSavedSearches = payload;
    },
    [Mutation.SET_LAWLEX_LOADING_STATUS](state, payload) {
        state.getLawlexLoadingStatus = payload;
    },
}
